module.exports = require('./../dist/svg-components/nerdwallet-brand/Savings');